import { Link } from 'react-router-dom';
import { getFormUrl } from '@/utils/form';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50 mx-4 md:mx-6 mb-4 md:mb-6 rounded-2xl overflow-hidden">
      <div className="px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h3 className="font-heading text-4xl font-bold mb-4">黑料吃瓜在线</h3>
            <p className="text-foreground-300 text-sm leading-relaxed mb-8 max-w-sm">
              这里是黑料吃瓜在线中心，每日更新热门网络爆料事件。娱乐圈黑料、主播网红塌房现场、在线吃瓜视频，一站掌握每日最热吃瓜资讯。
            </p>
            <form
             
              id="newsletter-form"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const antiSpam = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
                if (antiSpam) {
                  alert('订阅成功！感谢您的关注！');
                  form.reset();
                  return;
                }
                const formData = new FormData(form);
                formData.delete('website_alt');
                const submitAddr = await getFormUrl('Newsletter Signup');
                try {
                  const res = await fetch(submitAddr, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                  });
                  const text = await res.text();
                  let parsed: Record<string, unknown> | null = null;
                  try { parsed = JSON.parse(text); } catch { parsed = null; }
                  if (res.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
                    alert('订阅成功！感谢您的关注！');
                    form.reset();
                  } else {
                    const msg = (parsed && (parsed as Record<string, unknown>).meta && ((parsed as Record<string, unknown>).meta as Record<string, unknown>).message) || '订阅失败，请稍后重试';
                    alert(String(msg));
                  }
                } catch {
                  alert('订阅失败，请检查网络后重试');
                }
              }}
              className="flex flex-col sm:flex-row gap-3"
            >
              <input
                type="text"
                name="website_alt"
                className="form-anti-spam"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <input
                type="email"
                name="email"
                placeholder="输入邮箱订阅每日吃瓜爆料"
                required
                className="flex-1 bg-transparent border-b border-foreground-600 text-background-50 text-sm px-1 py-3 placeholder:text-foreground-500 focus:outline-none focus:border-accent-400 transition-colors"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-background-50 text-foreground-950 rounded-full text-sm font-semibold hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                订阅
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50 mb-5">快速导航</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline decoration-foreground-700 underline-offset-4">首页</Link>
              <Link to="/category/yulequan" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline decoration-foreground-700 underline-offset-4">娱乐圈黑料</Link>
              <Link to="/category/zhubo" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline decoration-foreground-700 underline-offset-4">主播塌房</Link>
              <Link to="/category/wanghong" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline decoration-foreground-700 underline-offset-4">网红八卦</Link>
              <Link to="/category/shehui" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline decoration-foreground-700 underline-offset-4">社会热点</Link>
              <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors underline decoration-foreground-700 underline-offset-4">关于我们</Link>
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold text-background-50 mb-5">联系我们</h4>
            <div className="flex flex-col gap-3 text-sm text-foreground-300">
              <p className="flex items-center gap-2"><i className="ri-mail-line"></i> hello@yusuwangluo.cn</p>
              <p className="flex items-center gap-2"><i className="ri-phone-line"></i> 400-888-6666</p>
            </div>
            <h4 className="text-sm font-semibold text-background-50 mt-8 mb-3">办公地址</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              北京市朝阳区建国路88号<br />
              SOHO现代城A座1208室
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800 mx-6 md:mx-10"></div>

      <div className="px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-6">
          <a href="http://yusuwangluo.cn/" target="_blank" rel="nofollow noopener" className="text-foreground-400 hover:text-background-50 transition-colors underline decoration-foreground-700 underline-offset-4 text-sm">微博</a>
          <a href="http://yusuwangluo.cn/" target="_blank" rel="nofollow noopener" className="text-foreground-400 hover:text-background-50 transition-colors underline decoration-foreground-700 underline-offset-4 text-sm">微信</a>
          <a href="http://yusuwangluo.cn/" target="_blank" rel="nofollow noopener" className="text-foreground-400 hover:text-background-50 transition-colors underline decoration-foreground-700 underline-offset-4 text-sm">抖音</a>
        </div>
        <p className="text-xs text-foreground-500">
          &copy; {new Date().getFullYear()} 黑料吃瓜在线 版权所有
        </p>
        <div className="flex items-center gap-6">
          <Link to="/about" className="text-xs text-foreground-400 hover:text-background-50 transition-colors underline decoration-foreground-700 underline-offset-4">隐私政策</Link>
          <Link to="/about" className="text-xs text-foreground-400 hover:text-background-50 transition-colors underline decoration-foreground-700 underline-offset-4">服务条款</Link>
        </div>
      </div>
    </footer>
  );
}